import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-artur-redirect',
  standalone: true,
  template: '',
})
export class ArturRedirectComponent implements OnInit {
  constructor(private router: Router) {}

  ngOnInit(): void {
    const isAngularDev =
      window.location.hostname === 'localhost' &&
      window.location.port === '4200';
    if (isAngularDev) {
      const currentPath = this.router.url.startsWith('/')
        ? this.router.url
        : `/${this.router.url}`;
      window.location.assign(`http://localhost:8184${currentPath}`);
      return;
    }

    // Production / VPS: Next.js is only behind nginx `location /artur/` (trailing
    // slash). Bare `/artur` hits Angular first; always send users to the canonical
    // Next entry (was `assign('/artur')` which reloaded Angular forever).
    const { origin, search, hash } = window.location;
    window.location.assign(`${origin}/artur/${search}${hash}`);
  }
}

